module.exports = __webpack_public_path__ + "img/Spokesperson_Grayscale.3aa5001a.jpg";